import { Box, ScrollView } from '@bonanza-social/moonlight';
import { memo, useEffect } from 'react';
import QuestItem from './QuestItem/QuestItem';
import { State, useDispatch, useSelector } from '@bonanza-social/toolkit/state';
import {
  fetchQuests,
  questNotFound,
  selectQuest,
  selectQuestsDataState,
} from '../state';
import QuestSkeleton from './QuestItem/components/QuestSkeleton';

function QuestDetails({ id }: { id: string | number }) {
  const dispatch = useDispatch();

  const quest = useSelector((state: State) => selectQuest(state, id));
  const questsDataState = useSelector(selectQuestsDataState);

  useEffect(() => {
    if (questsDataState === 'idle') {
      dispatch(fetchQuests());
    }
  }, [dispatch, questsDataState]);

  useEffect(() => {
    if (!quest || questsDataState === 'rejected') {
      dispatch(questNotFound());
    }
  }, [dispatch, quest, questsDataState]);

  if (questsDataState === 'idle' || questsDataState === 'pending') {
    return <QuestSkeleton />;
  }

  return (
    <ScrollView showsVerticalScrollIndicator={false}>
      <Box
        flex={1}
        paddingHorizontal={{
          mobile: 'space-400',
          tablet: 0,
          desktop: 0,
        }}
      >
        <QuestItem id={id} detailsPageView />
      </Box>
    </ScrollView>
  );
}

export default memo(QuestDetails);
